import { render } from "./AdminFulfillOrderModal.vue?vue&type=template&id=2c7a4c10"
import script from "./AdminFulfillOrderModal.vue?vue&type=script&lang=js"
export * from "./AdminFulfillOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__